// payments.js

import { url } from "./config";

const createPayment = async (amount, currency, description, email) => {
    console.log('createPayment:', amount, currency, description, email);
    try {
        const response = await fetch(url + '/api/create-payment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                amount: amount,
                currency: currency,
                description: description,
                email
            }),
        });

        const data = await response.json();
        
        if (response.ok) {
            console.log('Платеж создан:', data);
            return data.paymentUrl; // Возвращаем ссылку на оплату
        } else {
            throw new Error(data.error || 'Ошибка при создании платежа');
        }
    } catch (error) {
        console.error('Ошибка при запросе на создание платежа:', error);
        throw error;
    }
};

export { createPayment };
